import { render, staticRenderFns } from "./production-modal.vue?vue&type=template&id=4e195591&"
import script from "./production-modal.vue?vue&type=script&lang=js&"
export * from "./production-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports